import React from 'react';

const fmt = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

export default function IncomeTableVertical({ inputReport = [] }) {
  // 0. Убираем отчёт «TTM»
  const reports = inputReport.filter(r => r.fiscal_year !== 'TTM');

  // 1. Сортируем по убыванию fiscal_year (новый год слева)
  const sortedReports = [...reports].sort(
    (a, b) => Number(b.fiscal_year) - Number(a.fiscal_year)
  );

  // 2. Собираем все ключи, исключая 'fiscal_year' и 'period_ending'
  const metricKeys = Array.from(
    new Set(sortedReports.flatMap(Object.keys))
  ).filter((k) => k !== 'fiscal_year' && k !== 'period_ending');

  return (
    <div className="overflow-x-auto">
      <table className="linkedin-table min-w-full text-sm border">
        <thead>
          <tr className="bg-gray-100">
            <th className="py-2 px-4 text-left">Metric</th>
            {sortedReports.map((r, i) => (
              <th key={i} className="py-2 px-4 text-right !text-right">
                {r.fiscal_year ?? `Year ${i + 1}`}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {metricKeys.map((metric) => (
            <tr key={metric} className="border-t">
              <td className="py-2 px-4 font-medium min-w-[150px]">{metric}</td>
              {sortedReports.map((report, idx) => {
                const val = report[metric];
                return (
                  <td key={idx} className="py-2 px-4 text-right">
                    {val == null
                      ? '—'
                      : typeof val === 'number'
                      ? fmt.format(val)
                      : String(val)}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
